import { EntityType } from 'app/agriculture/models/Entities';

export const noteAttachOptionTypes: EntityType[] = [
    'Bridge Crossing',
    'Cool Room',
    'Dam',
    'Device',
    'Erosion Area',
    'Fence',
    'Gate',
    'Herd',
    'House',
    'Paddock',
    'Shed',
    'Silo',
    'Tank',
    'Trough',
    'Vegetation',
    'Waterway',
    'Yard',
];
